export default function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="flex-shrink-0 flex flex-col gap-2 py-3 px-4 md:h-16 md:flex-row md:items-center md:justify-between md:gap-3 md:py-0 md:px-8 border-b border-[#E9EDEF] sticky top-0 z-20 backdrop-blur-xl bg-white/80">
      <div className="min-w-0">
        {eyebrow && (
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8696A0]">{eyebrow}</p>
        )}
        <h1 className="font-heading text-lg md:text-xl font-medium tracking-tight text-[#111B21] truncate">{title}</h1>
        {subtitle && <p className="text-xs text-[#8696A0] truncate">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center flex-wrap gap-2 md:gap-3">{actions}</div>}
    </div>
  );
}
